// extracted by mini-css-extract-plugin
export default {"root":"HUm6AHtVcWHNVP2J46ZA"};